import { render } from "./AddBeneficiary.vue?vue&type=template&id=dcdc4a54"
import script from "./AddBeneficiary.vue?vue&type=script&lang=js"
export * from "./AddBeneficiary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__